import React, {useEffect, useState} from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import API_Service from '../../Services/API_Service';
import {empty, req_stock_brand} from '../../Helper/Constants';
import {useMediaQuery, useTheme} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	dlg: {
		minWidth: 300,
		margin: 5,
		marginLeft: 20,
		marginRight: 20
	},
	total: {
		float: 'left',
		color: 'grey',
		fontWeight: 'bold'
	},
	viewInRowSpace: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between'
	}
}));

export default function Addbrand({open, onClose, language, onSnack, axiosConfig}) {
	const classes = useStyles();
	const [brandCode, setBrandCode] = useState(empty);
	const [brandName, setBrandName] = useState(empty);

	useEffect(() => {

	}, [open]);

	const closeRemove = (data) => {
		setBrandCode(empty);
		setBrandName(empty);
		if (data) {
			onClose(data[0]);
		}
	}

	const addBrand = () => {
		let formData = new FormData();
		formData.append('brand_code', brandCode);
		formData.append('brand_name', brandName);

		if (brandName === empty || brandCode === empty) {
			onSnack('Insert brand Code and brand Name', 'warning');
		} else {
			API_Service.post(req_stock_brand, formData, axiosConfig).then(({data}) => {
				const {result, extraData} = data;
				if (result) {
					closeRemove(extraData);
					onSnack(language.insert_success);
				} else {
					onSnack(language.insert_fail, 'warning');
				}
			});
		}
	}

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Dialog fullScreen={fullScreen} onClose={() => onClose()} aria-labelledby="simple-dialog-title" open={open}>
			<DialogTitle id="simple-dialog-title">
				{language.new_brand}
			</DialogTitle>
			<div style={{width: 600, padding: theme.spacing(2)}}>
				<div className={classes.viewInRowSpace}>
					<TextField
						id="input-item-code"
						style={{width: '48%', height: 50}}
						inputProps={{maxLength: 10, pattern: "[a-z]{1,15}"}}
						label={language.brand_code}
						value={brandCode}
						onChange={(e) => setBrandCode(e.target.value)}
					/>
					<TextField
						id="input-item-name"
						style={{width: '48%', height: 50}}
						label={language.brand_name}
						value={brandName}
						onChange={(e) => setBrandName(e.target.value)}
					/>
				</div>
				<div style={{height: 20}}/>
				<div style={{display: "flex"}}>
					<Button
						style={{marginLeft: 'auto'}}
						variant="outlined"
						disabled={brandCode === empty || brandName === empty}
						onClick={() => {
							addBrand()
						}}
						color={'primary'}>
						{language.add}
					</Button>
				</div>
				<div style={{height: 20}}/>
			</div>
		</Dialog>
	)
}

